import { applyMiddleware } from 'redux';
import { apiMiddleware } from 'redux-api-middleware';
import thunk from 'redux-thunk';
import { getPaymentsForBiocatch } from '../../states/biocatch/selectors';
import { getApiBaseUrl, getApiBaseUrlPaas, getStaticContentWebAppLink } from '../../states/envConfig/selectors';
import * as sessionSelectors from '../../states/session/selectors';
import createApiMiddleware from './createApiMiddleware';
import createAuthHeaderMiddleware from './createAuthHeaderMiddleware';
import createBiocatchMiddleware from './createBiocatchMiddleware';
import createEndpointMiddleware from './createEndpointMiddleware';
import createStubMidleware from './createStubMiddleware';

const apiHeadersMiddleware = createApiMiddleware(sessionSelectors.getClientContext);
const authMiddleware = createAuthHeaderMiddleware(sessionSelectors.getToken);
const endpointMiddleware = createEndpointMiddleware(
	sessionSelectors.getBankId,
	getApiBaseUrl,
	getApiBaseUrlPaas,
	getStaticContentWebAppLink
);
const biocatchMiddleware = createBiocatchMiddleware(
	sessionSelectors.getClientContext,
	sessionSelectors.getToken,
	sessionSelectors.getBankId,
	getApiBaseUrl,
	getApiBaseUrlPaas,
	getPaymentsForBiocatch
);
const stubMiddleware =
	process.env.NODE_ENV === 'development' &&
	!/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/.test(window.location.search)
		? createStubMidleware()
		: false;

export const middlewares = [
	apiHeadersMiddleware,
	authMiddleware,
	endpointMiddleware,
	biocatchMiddleware,
	stubMiddleware,
	apiMiddleware,
	thunk,
].filter(Boolean);
export default applyMiddleware(...middlewares);
